module.exports = __webpack_public_path__ + "img/fraude.e972c221.jpg";